const resources = [
  {
    icon: "ri-camera-2-line",
    title: "Passport Photo Locations in Idaho Falls",
    items: [
      "Walgreens — W 17th St, Idaho Falls",
      "CVS Pharmacy — Idaho Falls location",
      "FedEx Office Print & Ship — Idaho Falls",
      "Walmart Photo Center — Idaho Falls",
    ],
  },
  {
    icon: "ri-id-card-line",
    title: "Idaho Driver's License / ID",
    items: [
      "ITD Driver's Services — 150 Shoup Ave W, Idaho Falls",
      "Bonneville County Sheriff — ID info",
      "ITD DMV — Ammon location available",
      "Idaho.gov — online renewal options",
    ],
  },
  {
    icon: "ri-plane-line",
    title: "Idaho Falls Regional Airport (IDA)",
    items: [
      "Airport — 2140 N Skyline Dr, Idaho Falls, ID 83402",
      "Connections via SLC, Seattle, Denver, LA",
      "TSA PreCheck enrollment — call ahead for schedule",
      "idafallsairport.com for schedules and parking",
    ],
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Idaho Falls Passport Applicants
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything you need to complete your passport application in the Idaho Falls area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {resources.map((r, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${r.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-3">{r.title}</h3>
              <ul className="space-y-2">
                {r.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}